export const SAGA_GET_MARCA = 'marcasReducer/SAGA_GET_MARCA';
export const SAGA_GET_MARCAS = 'marcasReducer/SAGA_GET_MARCAS';
export const SET_MARCAS = 'marcasReducer/SET_MARCAS';
export const SAVE_MARCA = 'marcasReducer/SAVE_MARCA';
export const SAGA_ELIMINAR_MARCA = 'marcasReducer/SAGA_ELIMINAR_MARCA';
export const SAGA_GET_MARCA_BY_CODIGO = 'marcasReducer/SAGA_GET_MARCA_BY_CODIGO';
export const SAGA_GET_MARCA_BY_NOMBRE = 'marcasReducer/SAGA_GET_MARCA_BY_NOMBRE';
export const SAGA_SAVE_MARCA = 'marcasReducer/SAGA_SAVE_MARCA';

export const sagaGetMarca = (idMarca) => ({
    type: SAGA_GET_MARCA,
    payload: { idMarca }
});

export const sagaGetMarcas = (nombre) => ({
    type: SAGA_GET_MARCAS,
    query: nombre,
});

export const setMarcas = (payload) => ({
    type: SET_MARCAS,
    payload
});

export const saveMarca = (payload) => ({
    type: SAVE_MARCA,
    payload
});

export const sagaEliminarMarca = (idMarca) => ({
    type: SAGA_ELIMINAR_MARCA,
    payload: { idMarca }
});

export const sagaGetMarcaByCodigo = (codigo) => ({
    type: SAGA_GET_MARCA_BY_CODIGO,
    payload: { codigo }
});

export const sagaGetMarcaByNombre = (nombre) => ({
    type: SAGA_GET_MARCA_BY_NOMBRE,
    payload: { nombre }
});

export const sagaSaveMarca = (payload) => ({
    type: SAGA_SAVE_MARCA,
    payload
});